import React from 'react';
import { Row, Card, Table, Col } from 'react-bootstrap';
import Chart from 'react-apexcharts';

export const DeviceOperationComponent = (props) => {
  return (
    <div>
      <Card>
        <Card.Title>
          <div style={{ textAlign: 'center', marginTop: '30px' }}>
            <h5 style={{ textAlign: 'center', marginBottom: '0' }}>Device Operation Schedule</h5>
          </div>
        </Card.Title>
        <Card.Body>
          <Row style={{ paddingLeft: '3%', paddingRight: '3%' }}>
            <Col md="12">
              <Table striped bordered hover size="sm">
                <thead>
                  <tr>
                    <th>System</th>
                    <th>Location</th>
                    <th>Day</th>
                    <th>On</th>
                    <th>Off</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Lighting System</td>
                    <td>Office</td>
                    <td>Mon-Fri</td>
                    <td>07:30</td>
                    <td>17:30</td>
                  </tr>
                  <tr>
                    <td>Lighting System</td>
                    <td>Outdoor</td>
                    <td>Mon-Sun</td>
                    <td>18:00</td>
                    <td>06:30</td>
                  </tr>
                  <tr>
                    <td>HVAC System</td>
                    <td>Office</td>
                    <td>Mon-Fri</td>
                    <td>07:30</td>
                    <td>17:30</td>
                  </tr>
                  <tr>
                    <td>Pump</td>
                    <td>Ground Floor</td>
                    <td>Mon-Fri</td>
                    <td>05:00</td>
                    <td>07:00</td>
                  </tr>
                </tbody>
              </Table>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <Chart
                series={props.plot_bar.series}
                options={props.plot_bar.options}
                type="bar"
                width="100%"
                height="300"
              />
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </div>
  );
};
